// extracted by mini-css-extract-plugin
export default {"form":"styles_form__7OEIl","input":"styles_input__02Bsb","photoContainer":"styles_photoContainer__4nQdE","image":"styles_image__REZWY"};